module.exports = __webpack_public_path__ + "img/logo-tufi-long.4d44e11f.png";